import React, {useEffect, useState} from 'react';
import HeaderWithBack from '../../components/HeaderWithBack';
import { useNavigate } from 'react-router';
import {toast} from "react-toastify";
import {CategoryDTO} from "../../dtos/category.dto";
import {useRecoilValue} from "recoil";
import {fetchAPIResponseSelector} from "../../store/user.atom";
import {IngredientDTO} from "../../dtos/ingredient.dto";
import {useParams} from "react-router-dom";

type Props = {};

const EditIngredient: React.FC<Props> = () => {

  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const fetchAPIResponse = useRecoilValue(fetchAPIResponseSelector);
  const [ingredientName, setIngredientName] = useState<string>('');
  const [ingredientPrice, setIngredientPrice] = useState<string>('');

  useEffect(() => {
    const fetchIngredient = async () => {
      try {
        const categoryData = await fetchAPIResponse<IngredientDTO>(`/ingredients/${id}`, {
          method: "GET",
          headers: {
            "Accept": "application/json"
          }
        });

        setIngredientName(categoryData.data.name);
        setIngredientPrice(categoryData.data.base_price.toFixed(2));
      } catch (error) {
        toast.error((error as Error).message)
      }
    };

    fetchIngredient();
  }, [id]);

  const handleEditIngredient = async () => {
    if(ingredientName === '' || ingredientPrice === '') {
      toast.error("Fill in contents before creating the ingredient")
      return;
    }

    try {
      await fetchAPIResponse<IngredientDTO>(`/ingredients/${id}`, {
        method: "PUT",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: ingredientName,
          base_price: Number(ingredientPrice)
        })
      });

      navigate('/ingredients')
    } catch (e) {
      toast.error((e as Error).message)
    }
  };

  return (
    <div className='flex flex-col w-full h-full overflow-auto items-center py-10'>
      <HeaderWithBack previousPage={'Ingredients'} currentPage={'Add Ingredient'} previousPageUrl={'/ingredients'} />
      <div className='bg-WhiteBg shadow-md w-11/12 px-12 py-6 mt-6 rounded-2xl'>
        <input
          type='text'
          placeholder='Ingredient Name'
          value={ingredientName}
          onChange={(e) => setIngredientName(e.target.value)}
          className='mt-4 p-2 block w-full shadow-sm focus:ring-primary focus:border-transparent border-primary rounded-md'
        />
        <input
          type='text'
          placeholder='Price'
          value={ingredientPrice}
          onChange={(e) => setIngredientPrice(e.target.value)}
          className='mt-4 p-2 block w-full shadow-sm focus:ring-primary focus:border-transparent border-primary rounded-md'
        />
        <button onClick={handleEditIngredient} className='bg-[#1490C2] text-white rounded-md p-2 mt-4 w-full'>
          Edit Ingredient
        </button>
      </div>
    </div>
  );
};

export default EditIngredient;
